import type { ReactNode } from 'react'

export function MathBlock({ children }: { children: ReactNode }) {
  return (
    <div className="not-prose my-6 rounded-lg bg-[#f0f4f8] border-l-4 border-[#C9A227] p-4 font-mono text-sm text-[#1B365D]">
      {children}
    </div>
  )
}
